// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const garbodor: PokeData = {
  "id": 569,
  "name": "garbodor",
  "height": 19,
  "weight": 1073,
  "base_experience": 166,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "body-slam",
    "take-down",
    "toxic",
    "sludge",
    "amnesia",
    "poison-gas",
    "explosion",
    "sludge-bomb",
    "pain-split",
    "metal-claw",
    "stockpile",
    "swallow",
    "recycle",
    "toxic-spikes",
    "gunk-shot",
    "acid-spray",
    "clear-smog",
    "belch"
  ],
  "moves": [
    "body-slam",
    "poison-gas",
    "sludge-bomb",
    "metal-claw",
    "toxic-spikes",
    "venom-drench",
    "acid-rain",
    "mortal-gas",
    "stun-spore",
    "acid",
    "poison-powder",
    "poison-fang",
    "purify"
  ],
  "evolution_chain": {
    "id": 290,
    "item": null,
    "species": [
      {
        "name": "trubbish",
        "order": 569,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "garbodor",
        "order": 570,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 568,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 120,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
